<template>
  <div class="other-website-card">
    <Upgrade-Popup
      v-if="showPopup"
      :upgradePopupType="upgradePopupType"
      v-on:clickedOutside="showPopup = false"
    />
    <Activation-Popup
      v-if="showActivationPopup"
      v-on:closed="showActivationPopup = false"
    />
    <Review-Popup
      v-if="showReviewPopup"
      v-on:reviewPopupClosed="showReviewPopup = false"
    />
    <Credit-Limit-Popup
      v-if="showCreditLimitPopup"
      v-on:clickedOutside="showCreditLimitPopup = false"
    />

    <div class="d-flex company-info-wrap">
      <CompanyInfo
        :companyData="companyData"
        :loadingCompany="loading"
        pageType="Other Website"
        :showSocialLinks="true"
      />
    </div>
    <div
      class="not-found-cinfo"
      v-if="!loading && (!companyData || !companyData.name)"
    >
      <div class="img-center">
        <img src="./../../assets/images/company.png" />
      </div>
      <p>Sorry, We couldn't find the company information for {{ domain }}</p>
    </div>

    <div class="top-contact-section d-flex animate-fadein">
      <div
        class="top-contact-head"
        v-if="
          companyData &&
          companyData.name &&
          !loading &&
          contactsData &&
          contactsData.length > 0
        "
      >
        Top Contacts in {{ companyData.name }}
      </div>
      <ul v-if="loading">
        <div class="top-contact-head linear-background"></div>
        <li v-for="index in 3" :key="index">
          <Contact-Card :loading="true" :fromBulk="false" />
        </li>
      </ul>
      <ul v-else-if="contactsData && contactsData.length > 0">
        <li v-for="(ele, index) in contactsData" :key="index">
          <Contact-Card
            :loading="false"
            :profileData="getContactData(ele)"
            :fromBulk="false"
            :updateEmail="updateEmail"
            :findEmailCallback="findEmailCallback"
            :enableReviewPopup="enableReviewPopup"
            :showUpgradePopup="showUpgradePopup"
            :updatePhone="updatePhone"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import sharedFunctions from './../../assets/util/functions.js'
import { MX_VIEW_ON_LINKEDIN_CLICKED } from './../../assets/util/constants/analytics.js'
import ContactCard from '@/components/ContactCard.vue'
import ReviewPopup from '@/components/ReviewPopup.vue'
import CreditLimitPopup from '@/components/CreditLimitPopup.vue'
import UpgradePopup from '@/components/UpgradePopup.vue'
import ActivationPopup from '@/components/ActivationPopup.vue'
import CompanyInfo from '@/components/companyInfo.vue'

export default {
  name: 'WebsiteCard',
  props: [
    'loading',
    'companyData',
    'contactsData',
    'totalContacts',
    'domain',
    'updateNewData',
  ],
  data: function () {
    return {
      copyState: false,
      showPopup: false,
      showActivationPopup: false,
      showReviewPopup: false,
      showCreditLimitPopup: false,
    }
  },
  components: {
    'Contact-Card': ContactCard,
    'Upgrade-Popup': UpgradePopup,
    'Activation-Popup': ActivationPopup,
    CompanyInfo: CompanyInfo,
    'Review-Popup': ReviewPopup,
    'Credit-Limit-Popup': CreditLimitPopup,
  },
  methods: {
    getContactData: function (data) {
      return {
        fullName: `${data.firstName} ${data.lastName}`,
        title: data.title,
        email: data.emailId,
        phone: data.phone,
        domain: data.primaryDomain,
        companyName: data.companyName,
        mcId: data.id,
        emailDeliverability: data.deliverability,
        linkedinId: data.linkedinId,
      }
    },
    enableReviewPopup() {
      this.showReviewPopup = true
    },
    showUpgradePopup(type) {
      if (type === 'credit_limit') {
        this.setShowCreditLimitPopup()
      } else {
        this.upgradePopupType = type
        this.showPopup = true
      }
    },
    setShowCreditLimitPopup() {
      this.showCreditLimitPopup = true
    },
    updateEmail(res) {
      const newData = this.contactsData.map((data) => {
        if (data.id === res.masterContactId) {
          return {
            ...data,
            emailId: res.email,
            contactAlreadyOwned: true,
          }
        }
        return data
      })
      this.updateNewData(newData)
    },
    updatePhone(phone, profileData) {
      const newData = this.contactsData.map((data) => {
        if (data.id === profileData.mcId) {
          return {
            ...data,
            phone: phone,
            ...(phone.length > 0 ? { contactAlreadyOwned: true } : {}),
          }
        }
        return data
      })
      this.updateNewData(newData)
    },
    findEmailCallback(response, autoTrigger) {
      let errorMessage = ''
      if (response && response.statusCode === '200') {
        this.updateEmail(response.response)
        if (autoTrigger) this.triggerFindEmail = true
        //get email is automatically clicked
      } else {
        errorMessage = response.errorMessage
      }
      return errorMessage
    },
    openLinkedInPage() {
      if (this.companyData && this.companyData.linkedInCompanyPageUrl)
        sharedFunctions.track(
          MX_VIEW_ON_LINKEDIN_CLICKED,
          null,
          this.$store.state
        )
      let url = this.companyData.linkedInCompanyPageUrl
      if (url.indexOf('http') == -1) url = `http://${url}`
      window.open(url)
    },
  },
  created() {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@mixin lineClamp($line) {
  display: -webkit-box;
  -webkit-line-clamp: $line;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
ul {
  margin: 0;
  list-style-type: none;
  padding: 0;
  li {
    display: flex;
    width: 100%;
    border-bottom: 1px solid rgba(59, 59, 59, 0.15);
  }
  li:last-child {
    border-bottom: none;
  }
}

.other-website-card {
  width: 100%;
  color: $grey-color;

  line-height: 22px;
  a {
    text-decoration: none;
  }
  .company-info-wrap {
    flex-direction: column;
  }

  .top-contact-section {
    padding: 10px 0;
    flex-direction: column;
    padding-bottom: 0;
    .top-contact-head {
      font-size: 16px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.02;
      letter-spacing: normal;
      text-align: left;
      color: #a6a6a6;
      padding: 5px 16px;
      &.linear-background {
        margin: 10px 16px;
        width: 150px;
      }
    }
  }

  .not-found-cinfo {
    padding: 25px 10px;
    color: $grey-color;
    text-align: center;
    p {
      margin-top: 15px;
      font-size: 15px;
    }
  }
}
</style>
